"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDashboardAttributeFilterElementsUrisToValues = exports.convertDashboardAttributeFilterElementsValuesToUris = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
// In KD, filter is always "uri" based. This is also way, how it's currently saved on panther/tiger (even though uris are actually values).
// In the past, we were relying on the fact, that tiger/panther does not support multiple labels and uri was always equal to the title.
// This is not correct anymore, so we need to send them as values also to AttributeFilter.
// When we are converting it back to "backend" shape, we need to preserve the previous expectations/behavior.
function convertDashboardAttributeFilterElementsValuesToUris(filter) {
    if (sdk_model_1.isAttributeElementsByRef(filter.attributeFilter.attributeElements)) {
        return filter;
    }
    return {
        attributeFilter: tslib_1.__assign(tslib_1.__assign({}, filter.attributeFilter), { attributeElements: {
                uris: filter.attributeFilter.attributeElements.values,
            } }),
    };
}
exports.convertDashboardAttributeFilterElementsValuesToUris = convertDashboardAttributeFilterElementsValuesToUris;
// In KD, filter is always "uri" based. This is also way, how it's currently saved on panther/tiger (even though uris are actually values).
// In the past, we were relying on the fact, that tiger/panther does not support multiple labels and uri was always equal to the title.
// This is not correct anymore, so we need to send them as values also to AttributeFilter.
function convertDashboardAttributeFilterElementsUrisToValues(filter) {
    if (sdk_model_1.isAttributeElementsByValue(filter.attributeFilter.attributeElements)) {
        return filter;
    }
    return {
        attributeFilter: tslib_1.__assign(tslib_1.__assign({}, filter.attributeFilter), { attributeElements: {
                values: filter.attributeFilter.attributeElements.uris,
            } }),
    };
}
exports.convertDashboardAttributeFilterElementsUrisToValues = convertDashboardAttributeFilterElementsUrisToValues;
//# sourceMappingURL=legacyFilterConvertors.js.map